// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salary-breakup-chart {
    width: 250px; /* Fixed width */
    height: 320px; /* Fixed height */
    text-align: center;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    overflow: hidden;
}

.salary-breakup-chart h3 {
    margin-top: 0%;
    font-size: 18px;
    font-weight: bold;
}

.salary-breakup-chart p {
    margin-top: -2%;
    color: #686868;
    font-size: small;
}

.salary-breakup-chart .chart-container {
    width: 100%; /* Full width */
    height: 180px; /* Fixed chart height */
}

.salary-amount-chart {
    font-size: 18px;
    font-weight: bold;
    color: #004DC6; /* Matches chart colors */
    margin-top: 10px;
}

.custom-legend-chart {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 12px;
    flex-wrap: wrap;
}

.legend-item-chart {
    display: flex;
    align-items: center;
    font-size: 10px;
}

.legend-color-chart {
    width: 12px;
    height: 12px;
    border-radius: 0px;
    display: inline-block;
    margin-right: 5px;
}

.chart-container-for-employee{
    width: 100%;  /* Ensure it takes full width */
    height: 250px; /* Increase the height */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/SalaryBreakupChart.css"],"names":[],"mappings":"AAAA;IACI,YAAY,EAAE,gBAAgB;IAC9B,aAAa,EAAE,iBAAiB;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW,EAAE,eAAe;IAC5B,aAAa,EAAE,uBAAuB;AAC1C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAE,yBAAyB;IACzC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW,GAAG,+BAA+B;IAC7C,aAAa,EAAE,wBAAwB;IACvC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".salary-breakup-chart {\n    width: 250px; /* Fixed width */\n    height: 320px; /* Fixed height */\n    text-align: center;\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    overflow: hidden;\n}\n\n.salary-breakup-chart h3 {\n    margin-top: 0%;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.salary-breakup-chart p {\n    margin-top: -2%;\n    color: #686868;\n    font-size: small;\n}\n\n.salary-breakup-chart .chart-container {\n    width: 100%; /* Full width */\n    height: 180px; /* Fixed chart height */\n}\n\n.salary-amount-chart {\n    font-size: 18px;\n    font-weight: bold;\n    color: #004DC6; /* Matches chart colors */\n    margin-top: 10px;\n}\n\n.custom-legend-chart {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 12px;\n    flex-wrap: wrap;\n}\n\n.legend-item-chart {\n    display: flex;\n    align-items: center;\n    font-size: 10px;\n}\n\n.legend-color-chart {\n    width: 12px;\n    height: 12px;\n    border-radius: 0px;\n    display: inline-block;\n    margin-right: 5px;\n}\n\n.chart-container-for-employee{\n    width: 100%;  /* Ensure it takes full width */\n    height: 250px; /* Increase the height */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
